let sendGoogleRematketingRequest = function(remarketingParams) {
    var img = document.createElement("img");
    img.onload = function(){};
    img.src = "//googleads.g.doubleclick.net/pagead/viewthroughconversion/992328503/?value=0&label=0VkDCMnlrAUQt_aW2QM&guid=ON&script=0&random=" + new Date().getTime() + "&data=" + encodeURIComponent($.param(remarketingParams).replace('&', ';'));
};

export default sendGoogleRematketingRequest;
